// Identifiants légaux selon le pays — miroir de backend/legal_identity.py
const MONACO = ["monaco", "mc", "principauté de monaco", "principaute de monaco", "mco"];
const FRANCE = ["france", "fr", "fra"];

export const countryCode = (country) => {
  const key = String(country || "").trim().toLowerCase();
  if (MONACO.includes(key)) return "MC";
  if (FRANCE.includes(key) || key === "") return "FR";
  return "XX";
};

// Champs d'identification légale à saisir et à afficher selon le pays.
// Monaco : RCI + DSEE (symétrique de la fiche société). France : SIRET. Ailleurs : identifiant local.
export const legalIdFields = (country) => {
  const code = countryCode(country);
  if (code === "MC") {
    return [
      { field: "rci", label: "RCI", placeholder: "10 S 05322" },
      { field: "dsee", label: "DSEE", placeholder: "514 S 14049" },
    ];
  }
  if (code === "FR") {
    return [{ field: "siret", label: "SIRET", placeholder: "123 456 789 00012" }];
  }
  return [{ field: "siret", label: "N° d'identification", placeholder: "Identifiant local" }];
};

// Premier identifiant (usage compact : en-tête de fiche, listes)
export const legalIdField = (country) => legalIdFields(country)[0];
